import React, { useState } from 'react'
import StatsComponent from '../common/StatsComponent'
export default function Users() {
    const [tableData,settableData] =useState([])
    const [statsOption, setStatsOption] = useState({
        "Total Loans Disbursed": "2400",
        "Approval Rate (%)": "32%",
        "Disbursement Rate (%)": "75%",
        "End‑to‑End TAT": "54 Hours",
        "Total API Cost": "₹120000",
        "API Cost per Disbursed Loan": "₹5000",
        "Wasted API Cost (%)": "35%",
        "Net Revenue per Loan": "₹22000",
    })
    return (
        <>
            <div style={{marginTop:window.innerWidth > 1800 ? "57px" :""}}>
                <StatsComponent
                    Data={statsOption}
                    showMoreButton={true}
                />
            </div>

            <div className="row"style={{marginTop:window.innerWidth > 1800 ? "57px" :""}}>
                      <div className="col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '20px' }}>
                          <div>
                            <h5>User Wise Detailed Table</h5>
                          </div>
                          <div className='main-customized-table'>
                            <table className='table'>
                              <thead>
                                <tr>
                                  <th>Loan Id</th>
                                  <th>Users</th>
                                  <th>API Name</th>
                                  <th>Hits</th>
                                  <th>Success</th>
                                  <th>Failed</th>
                                  <th>Cost</th>
                                  <th>Form Status</th>
                                  <th>Loan Status</th>
                                  <th>Drop Off Stage</th>
                                  <th>Error Codes</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  tableData?.length > 0 ? tableData?.map((val, id) => {
                                    return (
                                      <tr key={id}>
                                        <td></td>
                                      </tr>
                                    )
                                  })
                                    : ""}
                                {/* <tr>
                            <td><div className='successTd'>PI Nam</div></td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                            <td>PI Nam</td>
                          </tr> */}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
        </>
    )
}
